/**
 * @author xyguo
 * @description 角色管理==》人员维护==》添加人员==》查找人员,可在该角色下添加人员
 * @Date 2020/1/2
 */
import React from "react";
import { connect } from "dva";
import { modelUtils, Storage, jsonToString } from "@/utils";
import { Spin } from "antd";
import { utils_tool, component_tool, framework_tool } from "@/tool";
import {WizModalUserIdentityShow} from '@/containers/common';
const {
  WizCard,
  WizSearchBar,
  WizDataTable,
  WizListSelect,
  WizRow,
  WizCol
} = component_tool;
const { WizContainer } = framework_tool;
const { getPageData } = utils_tool;

import createColumns from "./listSelectColumns";

class ListSelect extends WizContainer {
  componentName = "ListSelect";

  constructor(props) {
    super(props);
    this.buildActionKey();
    this.state = {
      defaultSearch: true,
      apiParams: {},
      visible: false,
      record: null
    };
  }

  static defaultProps = {
    selectedRows: []
  }

  propsAndStateOnChange = {
    updateOrg: this._orgOnChange.bind(this),
    addOrg: this._orgOnChange.bind(this)
  };

  _orgOnChange(nextProps, nextState) {
    this._getData();
    return true;
  }

  _componentDidMount = () => {
    if (this.state.defaultSearch) {
      this._getData();
    }
  };

  _getData(other = {}) {
    this.doAction({

      path: 'organization/pageListByCond',
      payload: {
        key: "organizationListKey",
        apiParams: {
          ...this.state.apiParams, ...other,organizationNodeCategory:4
        }
      }
      

      // path: "organization/listByPage",
      // payload: {
      //   key: "organizationListKey",
      //   apiParams: { ...this.state.apiParams, ...other ,organizationNodeCategory:["4"]}
      // }
    });
  }

  _render() {
    const { organizationList, userManagementLoading, selectedRows, updateRows, handleClear } = this.props;
    const { record, visible } = this.state;
    const dataItems = getPageData(organizationList.data);
    const other = {};
    const columns = createColumns(this, dataItems, other);

    const searchBarProps = {
      columns,
      onSearch: values =>
        this.setState({ apiParams: values }, () => {
          this._getData();
        })
    };

    const dataTableProps = {
      loading: userManagementLoading,
      columns,
      rowKey: "id",
      dataItems,
      selectType: "checkbox",
      showNum: false,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        this._getData({ current: pageNum, size: pageSize });
      },
      selectedRowKeys: selectedRows.map(item => item.rowKey),
      onSelect: (keys, rows) => {
        this.keys = keys;
        updateRows(rows)
      }
    };

    const listSelectProps = {
      type: '组织',
      rows: selectedRows,
      handerClear: (id) => {
        handleClear(id)
      }
    }

    return (
      <WizRow>
        <WizCol span={16}>
          <WizCard bodyStyle={{ padding: '0 15px' }}>
            <WizSearchBar
              type="grid"
              {...searchBarProps}
              cols={{ xs: 14, md: 12, xl: 10 }}
            />
            <WizDataTable style={{ marginTop: 15 }} {...dataTableProps} />
            <div className="pagination">
              <WizDataTable.Pagination {...dataTableProps} />
            </div>
          </WizCard>
        </WizCol>
        <WizCol span={8} >
          <WizListSelect { ...listSelectProps } />
        </WizCol>
      </WizRow>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { organization } = state;
  const organizationList = modelUtils.getModelEntity(organization, "organizationListKey");
  const addOrg = modelUtils.getModelEntity(organization, "addOrg");
  const updateOrg = modelUtils.getModelEntity(organization, "updateOrg");
  const load = modelUtils.getLoadingState(state, "organization");
  return {
    organizationList: organizationList,
    addOrg,
    updateOrg,
    ...load
  };
};


export default connect(mapStateToProps)(ListSelect);
